import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';
import { OmmaContainerComponent } from './omma-container/omma-container.component';
import { UploadPropxComponent } from './upload-propx/upload-propx.component';

@NgModule({
  declarations: [UploadPropxComponent, OmmaContainerComponent],
  exports: [UploadPropxComponent, OmmaContainerComponent],
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, MaterialModule, SharedModule],
})
export class OmmaUploadModule {}
